import Header from "../../components/Header";
import './styles.css';
import IMAGE from '../../images/about.jpg';
import Footer from "../../components/Footer";

function About() {
  return (
    <div className="">
        <Header
        title={'About Us'}/>
        {/* About Us Content */}
        <section class="about-us">
            <div class="row">
                <div class="about-col">
                    <h1>The World Best University</h1>
                    <p>Welcome to Bright Eyes University, where brilliance meets opportunity. At Bright Eyes, we are committed to nurturing the intellectual curiosity and unlocking the potential of our students. Our university is known for its vibrant academic community, innovative programs, and a supportive environment that encourages personal growth. Here, you will find a campus buzzing with energy, where students are inspired to explore, question, and create.</p>
                    <p>At Bright Eyes University, we believe in the power of education to transform lives. Our distinguished faculty members are experts in their fields, dedicated to imparting knowledge and mentoring students to become critical thinkers and problem solvers. They engage students in lively discussions, encourage intellectual debates, and provide guidance for research and exploration.</p>
                </div>
                <div class="about-col" cla>
                    <img src={'https://images.unsplash.com/photo-1552581234-26160f608093?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8bWVldGluZ3xlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=500&q=60'} alt=""/>
                </div>
            </div>
        </section>

        <Footer/>
    </div>
  );
}

export default About;
